// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3wR9A","list":"styles_list__1jRde"};